import SmoothScrollbar from 'smooth-scrollbar';
import ScrollTriggerPlugin from '../animation/vendor/smooth-scrollbar/ScrollTriggerPlugin';
import SoftScrollPlugin from '../animation/vendor/smooth-scrollbar/SoftScrollPlugin';
import gsap from "gsap";
import {preloadImages, calcDrawImage} from "../animation/utills";

// GSAP ScrollTrigger & Soft Edges plugin for SmoothScroll
SmoothScrollbar.use(ScrollTriggerPlugin, SoftScrollPlugin);

// Init smooth scrollbar

if ($(window).width() >= '1010'){
	const view = document.getElementById('view-main');
	const scrollbar = SmoothScrollbar.init(view, {
		renderByPixels: false,
		damping: 0.020
	}); 
}


// Sequence trigger animation
(function () {

    // generate array of images paths. length = frames length, see: /src/assets/img
    //const urls = [...new Array(162)].map((value, index) => `https://atom-team.ru/img/${(index + 1)}.jpg`);

    var urls =  [];
    for (var i = 0; i < 500; i++) {
        //urls[i] = '../img/'+(i+1)+'.jpg';
        urls[i] = '../animation/animation-sprite/1 ('+(i+1)+').jpg';
    }
 
    // load images async
    const images = preloadImages(urls);


    const container = document.querySelector('.cb-sequence');
    const canvas = container.querySelector('canvas');
    const ctx = canvas.getContext('2d');

    // create "scrub" ScrollTrigger effect with pin of main block
    // pinType: transform is required when use pin with smooth scrollbar
    const tl = new gsap.timeline({
        scrollTrigger: {
            trigger: container,
            scrub: true,
            start: "top top",
            end: "500%", // scene duration
            pin: true,
            pinType: "transform",
            /*onToggle: self => console.log("toggled, isActive:", self.isActive),
            onUpdate: self => {
                console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
            }*/
        }
    });

    // canvas resize handler
    window.addEventListener('resize', function resize() {
        ctx.canvas.width = document.documentElement.clientWidth;
        ctx.canvas.height = document.documentElement.clientHeight;
        return resize;
    }());

    // when all images ready
    images.then((imgs) => {
        const counter = {i: 0}; // iteration object
        console.log(i);
        tl.to(counter, {
            i: imgs.length - 1, // increment counter to frames length
            roundProps: "i", // round, only int
            ease: "none", // ease provided by smooth-scroll momentum
            immediateRender: true, // render first frame immediately
            onUpdate: function(){
                calcDrawImage(ctx, imgs[counter.i]);
                console.log(counter.i);

                if(counter.i> 0) {
                    $('.step-1').show();
                    $('.super-animation-step-1').addClass('active');
                } else {
                    $('.super-animation-step-1').removeClass('active');
                }
                if(counter.i> 140) {
                    $('.super-animation-step-1').addClass('hide');
                } else {
                    $('.super-animation-step-1').removeClass('hide');
                }

                if(counter.i> 50) {
                    $('.super-animation-step-2').addClass('active');
                } else {
                    $('.super-animation-step-2').removeClass('active');
                }
                if(counter.i> 145) {
                    $('.super-animation-step-2').addClass('hide');
                } else {
                    $('.super-animation-step-2').removeClass('hide');
                }
                if(counter.i> 150) {
                    $('.step-1').hide();
                    $('.step-2').show();
                } else {
                    $('.step-1').show();
                    $('.step-2').hide();
                }

                if(counter.i> 180) {
                    $('.super-animation-step-3').addClass('active');
                } else {
                    $('.super-animation-step-3').removeClass('active');
                }

                if(counter.i> 320) {
                    $('.super-animation-step-3').addClass('hide');
                } else {
                    $('.super-animation-step-3').removeClass('hide');
                }

                if(counter.i> 230) {
                    $('.super-animation-step-3').addClass('mobile-hide');
                    $('.super-animation-step-4').addClass('active-1');
                } else {
                    $('.super-animation-step-3').removeClass('mobile-hide');
                    $('.super-animation-step-4').removeClass('active-1');
                }
                if(counter.i> 250) {
                    $('.super-animation-step-4').addClass('active-2');
                } else {
                    $('.super-animation-step-4').removeClass('active-2');
                }
                if(counter.i> 300) {
                    $('.super-animation-step-4').addClass('active-3');
                } else {
                    $('.super-animation-step-4').removeClass('active-3');
                }
                if(counter.i> 320) {
                    $('.super-animation-step-4').addClass('hide');
                } else {
                    $('.super-animation-step-4').removeClass('hide');
                }
                if(counter.i> 490) {
                    $('.step-3').show();
                    $('.step-2').hide();

                    $('.result-animate-1').addClass('active');
                    $('.result-animate-2').addClass('active');
                    $('.result-animate-3').addClass('active');
                    $('.result-animate-4').addClass('active');
                    $('.result-animate-5').addClass('active');
                    $('.result-animate-6').addClass('active');
                } else {
                    $('.step-3').hide();
                    $('.step-2').show();
                    $('.result-animate-1').removeClass('active');
                    $('.result-animate-2').removeClass('active');
                    $('.result-animate-3').removeClass('active');
                    $('.result-animate-4').removeClass('active');
                    $('.result-animate-5').removeClass('active');
                    $('.result-animate-6').removeClass('active');
                }
            }  
        }, 0);

        // draw current frame again when scroll stopped and resize happened
        window.addEventListener('resize', () => calcDrawImage(ctx, imgs[counter.i]));
    });

})();

$( document ).ready(function() {

	function getScrollBarWidth() {
		var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
			widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
		$outer.remove();
		return 100 - widthWithScroll;
	};

	setTimeout(function(){
		$(document).on('scroll', function (){
				var pageHeight = $('.cb-content').outerHeight(true);
				var footerHeight = $('.footer').outerHeight(true);
				var resultHeight = $('.animation-mobile__bottom').outerHeight(true);
				var blockHeght = footerHeight + resultHeight;
				var footerElement = pageHeight - blockHeght;
				var scrollArrow = $(document).scrollTop();
				var windowHeight = window.innerHeight;
				var right = getScrollBarWidth();
				/*if(scrollArrow > 100){
					$('.animation-mobile__bg').fadeIn();
				} else {
					$('.animation-mobile__bg').fadeOut();
				}*/
				//console.log(scrollArrow  +'>'+ (footerElement - windowHeight));
				if(scrollArrow  > (footerElement - windowHeight)) {
					$('.animation-mobile__bg').css({
						'position': 'absolute',
					});
					$('.animation-mobile__bg').addClass("absolute");
				} else {
					$('.animation-mobile__bg').css({
						'position': 'fixed',
					});
					$('.animation-mobile__bg').removeClass("absolute");
				}

		});
	}, 300);

	if ($(".animation-mobile").length > 0) {
		$(window).on('resize', function () {
			var new_width = $(window).outerWidth();
			var min_width = 760;
			console.log(new_width);
			var container = $('.animation-mobile');
			if (new_width <= min_width) {
				$('.animation-mobile .animation-questions').insertAfter($('.animation-mobile .animation-result__right'));
			}
			if (new_width > min_width) {
				$('.animation-mobile .animation-questions').insertAfter($('.animation-mobile .animation-download'));
			}
		}).trigger('resize');
	}
});
